import { Filters, ResultObject, TNameMap } from '../types';

export function processFilters(
	filters: Filters,
	nameMap: TNameMap,
): ResultObject[] {
	const result: ResultObject[] = [];
	const processedKeys = new Set<string>();

	for (const key in filters) {
		if (key.includes('__gte') || key.includes('__lte')) {
			const baseKey = key.replace(/__(gte|lte)$/, '');

			if (processedKeys.has(baseKey)) {
				continue;
			}

			const gteKey = `${baseKey}__gte`;
			const lteKey = `${baseKey}__lte`;

			const gteValue = filters[gteKey as keyof Filters];
			const lteValue = filters[lteKey as keyof Filters];

			const displayName = nameMap.get(gteKey) || nameMap.get(lteKey);

			if (displayName) {
				let range = '';
				if (gteValue !== undefined) {
					range += `от ${gteValue} `;
				}

				if (lteValue !== undefined) {
					range += `до ${lteValue}`;
				}

				if (range.trim()) {
					result.push({
						name: `${displayName.name}: ${range.trim()}`,
						id: [gteKey, lteKey].filter(key => filters[key]),
					});
				}

				processedKeys.add(baseKey);
			}
		}
	}

	for (const key in filters) {
		if (processedKeys.has(key.replace(/__(gte|lte)$/, ''))) {
			continue;
		}

		const value = filters[key as keyof Filters] as string;
		if (value) {
			const displayName = nameMap.get(key);
			if (!displayName) continue;

			let name = '';
			if (Array.isArray(value)) {
				name =
					value.length > 1
						? `${displayName.name}: ${value.length}`
						: `${displayName.name}: ${
								displayName.namesMap?.get(value[0]) || value[0]
						  }`;
			} else {
				name = `${displayName.name}: ${
					displayName.namesMap?.get(value) || value
				}`;
			}

			if (name) {
				result.push({
					name,
					id: [key],
				});
			}
		}
	}

	return result;
}
